// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1325":"0fd304a6","2354":"33a439fc","3512":"66fc8483","6124":"62993e8b"}[chunkId] + ".chunk.css";
};